import Modal from "react-bootstrap/Modal";
import { modalClose } from "../../../../../images";
import "./pendingVerification.scss";
import useTheme from "../../../../../components/useTheme/useTheme";

const PendingVerification = (props) => {
  const { theme } = useTheme();
  return (
    <>
      <Modal
        {...props}
        centered
        className={`Complete_actions_popup edit_social_link_b_connect_edit pending_verifcation_modal  ${
          theme === "dark" && "add-location-popup--dark-mode"
        }`}
        backdropClassName={`custom-backdrop ${
          theme === "dark" && "add-location-popup--dark-mode-bckd"
        }`}
      > 
        <Modal.Header>
          <button
            className="Complete_actions_popup_cancel_btn"
            onClick={props.onHide}
          >
            <img
              src={modalClose}
              alt="close-icon"
              className="Complete_actions_popup_cancel_btn_img"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Complete_actions_popup_m_heading social_link_edi_heading">
            Pending Verification
          </h2>

          <p className="desc_msg_pending_verification">
            Your Verification Request Is Currently Under Process. We Will Notify
            You Once The Verification Is Complete.
          </p>

          <button
            type="submit"
            className="confirmation_common_btn confirmation_cmn_edit_coonect_btn"
            onClick={props.onHide}
          >
            Okay, Got it!
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PendingVerification;
